<template>
  <el-row>
    <el-col :span="20" :offset="4">
      <plant-calendar :begin="begin" :duration="190"></plant-calendar>
    </el-col>
  </el-row>
</template> 
 <script>
import PlantCalendar from './PlantCalendar.vue'
export default {
  name: 'SelfCalendar',
  components: { PlantCalendar },
  data() {
    return {
      begin: undefined,
      end: undefined,
    }
  },
  created() {
    this.begin = new Date(new Date().getTime() + 10 * 24 * 3600 * 1000)
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_sample/Calendar.vue